import { setSendMessagePending } from './actions';
import { trackMessageSent } from './tracking';
import { CHATBOT_ID } from '../../constants/chatbotId';
import {
  currentChatGaProductsSelector,
  currentChatMlSearchSessionGuidSelector,
  currentChatOwnerIdSelector,
  isEarlyAccessSelector,
  userIdSelector,
} from '../../selectors';
import { TThunkAction } from '../../types/redux/thunk';
import { createOutcomingMessage, prepareMessageReply } from '../../utils/messageUtils';
import { sendWsMessage } from '../wsMessage';
import { IWsMessageReply } from '../wsMessage/types';

interface ISendMessageParams {
  text: string;
  chatId: string;
  messageId?: string;
  payload?: string | null;
  reply?: IWsMessageReply | null;
}

export const sendMessage =
  ({ text, chatId, messageId, payload, reply }: ISendMessageParams): TThunkAction<void> =>
  async (dispatch, getState, { custom: { messagesMap } }) => {
    const state = getState();
    const userId = userIdSelector(state);
    const ownerId = currentChatOwnerIdSelector(state);
    const mlSearchSessionGuid = currentChatMlSearchSessionGuidSelector(state);
    const isEarlyAccess = isEarlyAccessSelector(state);
    const products = currentChatGaProductsSelector(state);

    const messageReply = prepareMessageReply({ messagesMap, replyToMessageId: reply?.messageId });

    const message = createOutcomingMessage({ text, chatId, userId, payload, reply: messageReply });

    trackMessageSent({
      chatId,
      messageId: message.messageId,
      isReply: Boolean(messageReply),
      ownerId,
      mlSearchSessionGuid,
      isEarlyAccess,
      chatBotToAuthor: chatId === CHATBOT_ID,
      products,
    });

    dispatch(
      setSendMessagePending({
        message,
        messageId: messageId || message.messageId,
        messagesMap,
      }),
    );

    await dispatch(sendWsMessage({ message, reply }));
  };
